module.exports = __webpack_public_path__ + "img/baotuanshiyanglao_image_ylms.ee394a10.png";